import Footer from 'components/Footer';
import Navbar from 'components/Navbar';
import { useNavigate } from 'react-router-dom';

import { works } from 'data/portfolioData';
import { PortfolioType } from 'components/portfolios';

const Portfolio = () => {
  const navigate = useNavigate();

  /* -----------------------------
     CATEGORY LIST
  ----------------------------- */

  const categories = [...new Set(works.map((w) => w.category))];

  return (
    <section className='bg-white min-h-screen'>
      <Navbar />

      <div className='max-w-7xl mx-auto pt-40 px-6 md:px-8'>
        {/* HEADER */}

        <div className='mb-24 max-w-2xl'>
          <p className='text-sm uppercase tracking-widest text-neutral-400 mb-4'>
            Portfolio
          </p>

          <h1 className='text-5xl md:text-6xl font-semibold mb-6 leading-tight'>
            Design Categories
          </h1>
        </div>

        {/* CATEGORY SECTIONS */}

        {categories.map((category) => {
          const items = works.filter((w) => w.category === category);

          return (
            <div key={category} className='mb-24'>
              {/* CATEGORY TITLE */}

              <h2 className='text-3xl font-semibold mb-10'>{category}</h2>

              {/* GRID */}

              <div
                className='
                  grid
                  grid-cols-1
                  sm:grid-cols-2
                  lg:grid-cols-4
                  gap-8
                '
              >
                {items.map((item, index) => {
                  const rotate =
                    index % 2 === 0 ? 'rotate-[-0.5deg]' : 'rotate-[0.5deg]';

                  return (
                    <PortfolioType
                      key={item.id}
                      id={item.id}
                      title={item.title}
                      img={item.img}
                      category={item.category}
                      rotate={rotate}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      <Footer />
    </section>
  );
};

export default Portfolio;
